<template>
  <section class="_pbs _pt0">
    <async-loader v-if="invoicesLoading"/>
    <div v-else container>
      <div class="card">
        <div grid="row wrap" class="align-center">
          <div column="xs-6 s-6 m-8">
            <label>
              current balance:
            </label>
            <h2>
              {{toDollarFormat(currentBalanceDue)}}
              <tool-tip
                right
                class="sun"
                style="font-size: 1rem;"
                message="Don't see a payment you made reflected below or in your balance? Send us an email on the Contacts Page. We're happy to help!">
                <font-awesome-icon icon="question-circle" aria-label="Tooltip question mark"/>
              </tool-tip>
              <span class="color-black ml-2" style="font-size: 1rem" v-html="billingSummaryTotalText"></span>
            </h2>
          </div>
          <div column="xs-6 s-3 m-4">
            <div v-if="paymentsAvailable && !isInternalUser">
              <h5 v-if="currentBalanceDue < 0" class="_text-center">
                No Payment Due
              </h5>
              <router-link
                class="btn sun --sm -full-width"
                :class="{ '_mbxs': paymentHistoryEnabled }"
                :to="{ name: 'make-payment' }"
                :disabled="currentBalanceDue < 0"
                :event="currentBalanceDue >= 0 ? 'click' : ''"
              >
                make payment
              </router-link>
            </div>
            <div v-if="invoicePaymentHistory.length">
              <button
                type="button"
                v-if="paymentHistoryEnabled"
                class="btn sun white --sm -full-width"
                @click="onDownload"
              >
                Download Payment History
            </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import billing from '@mixins/billing'
  import ToolTip from '@molecules/ToolTip'
  import formattable from '@mixins/formattable'

  export default {
    components: { ToolTip },
    mixins: [billing, formattable],
    computed: {
      billingSummaryTotalText() {
        return this.$store.state.cloudCannon.cloudCannonContent.billing_summary_total
      }
    },
    methods: {
      onDownload() {
        this.$emit('download-clicked');
      }
    }
  }
</script>
<style scoped lang="scss">
.card {
  margin: 0;
  padding: 1.50rem;
}
h2 {
  margin: 0;
}
.flex-wrap {
  align-items: center;
  .btn {
    margin-left: auto;
  }
  border-bottom: 1px solid $color-border;
}
</style>

